var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 23,
    viewBox: "0 0 72 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5699 17.7109H26.9918L25.5718 21.815H21.0352L28.7802 0.246094H33.8106L41.5556 21.815H36.9884L35.5699 17.7109ZM34.396 14.255L31.2794 5.24437L28.1642 14.255H34.396Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8419 6.75758C57.3482 5.85317 56.6695 5.16431 55.8059 4.68953C54.9422 4.21621 53.9344 3.98028 52.7824 3.98028C51.5066 3.98028 50.375 4.26864 49.3876 4.8439C48.4001 5.42063 47.6282 6.24348 47.0734 7.31246C46.5185 8.38289 46.2403 9.61644 46.2403 11.0146C46.2403 12.4549 46.5228 13.7103 47.0894 14.7793C47.6545 15.8497 48.4424 16.6726 49.4502 17.2478C50.458 17.8246 51.6304 18.1115 52.9674 18.1115C54.6131 18.1115 55.9602 17.6746 57.0088 16.8007C58.0574 15.9269 58.7463 14.7079 59.0769 13.1438H51.6712V9.84219H63.3354V13.6069C63.047 15.1084 62.4295 16.4978 61.4843 17.7721C60.5377 19.0479 59.3187 20.0703 57.8273 20.8422C56.336 21.6141 54.664 22 52.813 22C50.7347 22 48.8574 21.5325 47.1811 20.5961C45.5048 19.6596 44.1883 18.3591 43.2314 16.693C42.2746 15.0269 41.7969 13.135 41.7969 11.016C41.7969 8.897 42.2746 6.99934 43.2314 5.32305C44.1883 3.64677 45.5048 2.3404 47.1811 1.40395C48.8574 0.467499 50.7245 0 52.7809 0C55.2087 0 57.3176 0.591287 59.106 1.77386C60.8959 2.95644 62.1295 4.61816 62.8082 6.75758H57.8419Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3665 0.276367V21.8147H66.0469V0.276367H70.3665Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3748 5.38437C19.4383 3.74886 18.1115 2.4891 16.3944 1.60508C14.6759 0.721061 12.6865 0.27832 10.4233 0.27832H7.21484V3.91926H10.2703C12.5336 3.91926 14.2812 4.55132 15.5162 5.81691C16.7498 7.0825 17.3673 8.83598 17.3673 11.0773C17.3673 13.3202 16.7498 15.0576 15.5162 16.2926C14.2812 17.5276 12.5336 18.234 10.2703 18.234H7.21484V21.8166H10.4247C12.6879 21.8166 14.6774 21.3739 16.3959 20.4899C18.113 19.6059 19.4398 18.3563 20.3762 16.7412C21.3127 15.1261 21.7802 13.2386 21.7802 11.0788C21.7787 8.91754 21.3112 7.01988 20.3748 5.38437Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21049 3.91895H3.60156V7.50163H7.21049V3.91895Z",
    fill: "#FF610A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60893 7.49707H0V11.0798H3.60893V7.49707Z",
    fill: "#FF610A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000448465 18.2363H3.60938L3.60938 14.6536H0.000448465L0.000448465 18.2363Z",
    fill: "#FF610A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60592 14.6582H7.21484V11.0755H3.60592L3.60592 14.6582Z",
    fill: "#FF610A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60592 21.8154H7.21484V18.2328H3.60592L3.60592 21.8154Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.315ade9db97b50eda8580dac43a59d8c.svg";
export { ForwardRef as ReactComponent };